/*
Example state:
(note that the store expects a Javascript Date object)

export default {
  byId: {
    msg1: {
      id: 'msg1',
      content: { type: 'text', body: 'a message the customer sent' },
      date: new Date('2013-02-08 09:00:00+07:00'),
      participantId: 'user',
      _isSending: false,
      _hasError: false,
      _errors: [],
    },
    msg2: {
      id: 'msg2',
      content: { type: 'text', body: 'a message the agent sent' },
      date: new Date('2013-02-08 09:00:10+07:00'),
      participantId: 'agent1',
    },
  },
  allIds: ['msg1', 'msg2'],
  pending: [
    {message: <Message text>}
  ]
};

*/

export default {
  byId: {},
  allIds: [],
  pending: [],
};
